import api from './api';

export interface Transporte {
  id?: number;
  nombre?: string;
  codigo?: string | number;
  nombreExpreso?: string;
  nroExpreso?: number | string;
  formaEntrega?: string | null;
}

const transporteService = {
  getTransportes: async (): Promise<Transporte[]> => {
    const resp = await api.get('/api/Transportes');
    const data = resp.data;
    if (Array.isArray(data)) return data as Transporte[];
    if (Array.isArray(data?.items)) return data.items as Transporte[];
    return [];
  },
  
  getTransporte: async (nroExpreso: number | string): Promise<Transporte | null> => {
    try {
      const resp = await api.get(`/api/Transportes/${nroExpreso}`);
      return resp.data as Transporte;
    } catch (error) {
      console.error(`Error al obtener transporte ${nroExpreso}:`, error);
      return null;
    }
  },
};

export default transporteService;


